export const commonJobRoles = [
    "All Roles",
    "AC Technician",
    "Account Manager",
    "Accountant",
    "Admin Executive",
    "Admin Manager",
    "Agriculture / Dairy",
    "Air Hostess / Cabin Crew",
    "Architect",
    "Area Sales Manager",
    "Artist / Photographer",
    "BPO / Telecaller",
    "Back Office Executive",
    "Banking Executive",
    "Barista",
    "Bartender",
    "Beautician / Spa Therapist",
    "Biologist",
    "Branch Coordinator",
    "Branch Manager",
    "Business Analyst",
    "Business Development Executive",
    "Business Development Manager",
    "Business Head",
    "Business Intelligence Analyst",
    "Business Owner",
    "CEO",
    "CFO",
    "COO",
    "CRM Executive",
    "Cameraman",
    "Carpenter",
    "Cashier",
    "Chartered Accountant",
    "Chef / Cook",
    "Chemical Engineer",
    "Chemist",
    "Civil Engineer",
    "Cleaner / Helper",
    "Cleaner / Housekeeping Staff",
    "Cloud Architect",
    "Co-Founder",
    "Collection Executive",
    "Company Director",
    "Company Owner",
    "Computer Operator",
    "Construction Worker",
    "Consultant",
    "Content Writer",
    "Corporate Trainer",
    "Counselor",
    "Courier / Delivery Boy",
    "Customer Care Executive",
    "Customer Support Executive",
    "Customer Support Manager",
    "Data Analyst",
    "Data Entry Operator",
    "Data Scientist",
    "Database Administrator",
    "Delivery Boy",
    "Delivery Executive",
    "Dentist",
    "Design Engineer",
    "DevOps Engineer",
    "Dietician / Nutritionist",
    "Digital Marketing Executive",
    "Director Operations",
    "Doctor",
    "Draftsman",
    "Driver",
    "Driver Supervisor",
    "Economist",
    "Editor",
    "Electrical Engineer",
    "Electrician",
    "Embedded Systems Engineer",
    "Event Planner",
    "Factory Worker",
    "Fashion Designer",
    "Field Executive",
    "Field Manager",
    "Field Sales Executive",
    "Field Worker",
    "Finance Manager",
    "Financial Analyst",
    "Firefighter",
    "Fitness Trainer / Gym Instructor",
    "Flight Engineer",
    "Floor Manager",
    "Founder",
    "Front Office / Receptionist",
    "Full Stack Developer",
    "Gardener",
    "General Manager",
    "Geologist",
    "Graphic Designer",
    "Guest Relations Executive",
    "HR Executive",
    "HR Executive / Recruiter",
    "HR Head",
    "HR Manager",
    "HVAC Technician",
    "Hairdresser / Hairstylist",
    "Hardware Engineer",
    "Helper",
    "Home Maid / Housekeeper",
    "Hospitality Executive",
    "Hotel Manager",
    "Housekeeping Staff",
    "IT Support Specialist",
    "Industrial Engineer",
    "Interior Designer",
    "Interpreter / Translator",
    "Investment Banker",
    "Journalist / Reporter",
    "Junior Accountant",
    "Kitchen Helper",
    "Lab Technician",
    "Laborer",
    "Lawyer / Advocate",
    "Legal Advisor",
    "Librarian",
    "Lift Operator",
    "Loader / Unloader",
    "Loan Officer",
    "Logistics Executive",
    "Logistics Manager",
    "Machine Operator",
    "Maintenance Technician",
    "Makeup Artist",
    "Management Consultant",
    "Managing Director",
    "Managing Partner",
    "Manufacturing Executive",
    "Marketing Executive",
    "Marketing Manager",
    "Mason",
    "Massage Therapist",
    "Mathematician",
    "MEAN Stack Developer",
    "Mechanic",
    "Mechanical Engineer",
    "Medical Representative",
    "MERN Stack Developer",
    "Microbiologist",
    "Mobile App Developer",
    "Mobile Technician",
    "Model",
    "Musician",
    "Network Engineer",
    "Nurse",
    "Office Assistant",
    "Office Assistant / Peon",
    "Office Boy / Peon",
    "Operation Executive",
    "Operations Head",
    "Operations Manager",
    "Optometrist",
    "PR Executive",
    "Packer / Mover",
    "Packing Staff",
    "Painter",
    "Paralegal",
    "Pathologist",
    "Personal Assistant",
    "Pet Groomer",
    "Pharmacist",
    "Photographer",
    "Physiotherapist",
    "Pilot",
    "Plant Manager",
    "Plumber",
    "Police Officer",
    "Policy Analyst",
    "Product Manager",
    "Production Supervisor",
    "Professor / Lecturer",
    "Program Manager",
    "Project Coordinator",
    "Project Manager",
    "Psychologist",
    "Purchase Executive",
    "Quality Assurance / QA",
    "Quality Control Inspector",
    "Quality Executive",
    "Radiologist",
    "Real Estate Agent",
    "Receptionist",
    "Recruiter",
    "Regional Manager",
    "Relationship Officer",
    "Research Analyst",
    "Restaurant Manager",
    "Retail Associate",
    "Rigger",
    "SEO Executive",
    "Safety Officer",
    "Sales Associate",
    "Sales Executive",
    "Sales Head",
    "Sales Manager",
    "Sales Officer",
    "Scientist",
    "Security Guard",
    "Security Supervisor",
    "Senior Accountant",
    "Senior Manager",
    "Senior Sales Executive",
    "Senior Telecaller",
    "Service Technician",
    "Shift Supervisor",
    "Shop Assistant",
    "Singer",
    "Site Supervisor",
    "Social Media Executive",
    "Social Media Manager",
    "Social Worker",
    "Software Developer",
    "Software Tester",
    "Sound Engineer",
    "Sports Coach",
    "Statistician",
    "Store Helper",
    "Store Keeper",
    "Store Manager",
    "Supervisor",
    "Surgeon",
    "Surveyor",
    "System Administrator",
    "Tailor",
    "Teacher / Tutor",
    "Team Leader",
    "Team Manager",
    "Technician",
    "Telecaller",
    "Telemarketer",
    "Teller",
    "Textile Designer",
    "Ticketing Executive",
    "Tour Guide",
    "Traffic Warden",
    "Trainer",
    "Travel Agent",
    "Truck Driver",
    "Typist",
    "UI/UX Designer",
    "Veterinarian",
    "Vice President Operations",
    "Vice President Sales",
    "Video Editor",
    "Videographer",
    "Waiter",
    "Waiter / Steward",
    "Warehouse Executive",
    "Warehouse Helper",
    "Watchman",
    "Web Designer",
    "Web Developer",
    "Welder",
    "Writer / Author",
    "Yoga Instructor",
    "Zoologist"
];
